import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PathwaysBox.css';
import { useTranslation } from 'react-i18next'; // Step 1
import { getRandomImage, getUserName } from '../../hooks/helpers';
import { IBLSpinLoader } from '../IBLSpinLoader';
import { inIframe } from '../../utils';
import { getContentCompletionData } from '../../hooks';

export const PathwaysBox = ({ userPathwaysLoaded, userPathways, username, isAssignedPathway=false, showProgressBar=false }) => {

  const { t } = useTranslation('library'); // Step 2

  if (!userPathwaysLoaded) {
    return <IBLSpinLoader size={40} containerHeight="150px" />;
  }

  return (
    <div className="div-block-430 sl pathway_grid">
      {!inIframe() && !isAssignedPathway && (
        <div
          id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
          className="item-box path_box custom_box"
        >
          <Link
            to="/profile/pathways/new"
            className="link-block-31 w-inline-block"
          >
            <div className="div-block-444">
              <div className="div-block-394">
                <img
                  src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                  loading="lazy"
                  alt=""
                  className="image-142"
                />
              </div>
              <div className="c_p">{t('Create Pathway')}</div>
            </div>
          </Link>
        </div>
      )}

      {userPathways?.map((pathway, index) => (
        <SinglePathwayBox pathway={pathway} key={index} isAssignedPathway={isAssignedPathway} index={index} showProgressBar={showProgressBar} username={username} />
      ))}
    </div>
  );
};


const SinglePathwayBox = ({pathway, username, index, showProgressBar, isAssignedPathway=false}) : React.JSX.Element => {
  const { t } = useTranslation('library');
  const [randomImageUrl, setRandomImageUrl] = useState('');
  useEffect(() => {
    setRandomImageUrl(getRandomImage());
  }, []);

  const [completionData, setCompletionData] = useState({
    completion_percentage:null,
    count:0
  })

  const handleCompletionDataFetch = async () =>{
    getContentCompletionData({
      pathway_uuid: pathway?.pathway_uuid,
      username:getUserName()
    }, 'pathway', (data)=>{
      setCompletionData({
        completion_percentage: Math.floor(data.completion_percentage),
        count: data?.count
      })
    })
  }

  const getPathwaysParams = (pathwayData:any) => {
    return new URLSearchParams({
      ...(isAssignedPathway ? {
        "is-assigned-pathway":"true",
      } : {}),
      platform:isAssignedPathway ? pathwayData?.pathway_platform_key : pathwayData?.platform_key
    }).toString()
  }

  useEffect(() => {
    if(showProgressBar){
      handleCompletionDataFetch()
    }
  }, []);

  return (
    <div
      key={index}
      id="w-node-_9d122df3-5436-acb4-d16f-30b76ec43f9d-27264aa9"
      className="item-box path_box"
    >
      <Link
        to={`/profile/pathways/${pathway.pathway_uuid}/${username}/?${getPathwaysParams(pathway)}`}
        className="link-block-31 w-inline-block"
      >
        <div className="div-block-411">
          <img
            src={randomImageUrl}
            loading="lazy"
            sizes="(max-width: 767px) 234px, (max-width: 991px) 295.734375px, (max-width: 1279px) 21vw, 226.5px"
            alt="pathway-image"
            className="image-155"
          />
          <div className="label c">
            <div className="text-block-294">{t('PATHWAY')}</div>
          </div>
        </div>
        <div className="item-body">
          <div className="div-block-417">
            <div className="div-block-461">
              <img
                src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google.png"
                loading="lazy"
                sizes="100vw"
                srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google.png 512w"
                alt=""
                className="image-167"
              />
            </div>
            <div className="text-block-235">{t('Google')}</div>
            <div className="div-block-523">
              <div className="text-block-233">{t('120 Skill Coins')}</div>
            </div>
          </div>
          <div className="text-block-225">{pathway.name}</div>
          {
            showProgressBar && completionData?.completion_percentage ? (
              <div className="w-layout-vflex content-progress-bar-block">
                <div className="w-layout-hflex content-progress-bar-top-block">
                  <div className="content-progress-bar-title">Progress</div>
                  <div className="content-progress-bar-percentage">{completionData?.completion_percentage}%</div>
                </div>
                <div className="content-progress-bar-slider-block">
                  <div className="content-progress-bar-slider-percentage-block" style={{
                    width: `${completionData?.completion_percentage}%`
                  }}></div>
                </div>
              </div>
            ) : <></>
          }
        </div>
      </Link>
    </div>
  )
}